import { useQuery } from '@tanstack/react-query'
import { api, unwrapFaqList } from '@astro/api'

/** GET /faqs?type=shop — normalized to the {q, a} shape FaqSection renders. */
export function useFaqs() {
  const query = useQuery({
    queryKey: ['faqs', 'shop'],
    queryFn: () => api.faqs.list({ type: 'shop' }),
    select: (res) => unwrapFaqList(res).map(({ question, answer }) => ({ q: question, a: answer })),
  })
  return {
    faqs: query.data ?? [],
    isPending: query.isPending,
    isError: query.isError,
  }
}
